export interface ConfigItem {
    id: string;
    name: string;
}

export interface Config {
    guide: any;
    genres: ConfigItem[];
    cuisines: ConfigItem[];
    types: ConfigItem[];
    occasions: ConfigItem[];
    neighborhoods: ConfigItem[];
}

